<div class="w-100 loading-peq">
  <img src="./assets/img/{{ customTheme }}/Waiting_points.gif" />
</div>
